{
  "version": 1,
  "asset_id": "adcc79ee-9ea0-46e3-b5d5-3054b5b75d7b",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/adcc79ee-9ea0-46e3-b5d5-3054b5b75d7b/7-secrets-cover.png",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/adcc79ee-9ea0-46e3-b5d5-3054b5b75d7b/7-secrets-cover.png",
  "original_filename": "7-secrets-cover.png",
  "size": 82519,
  "content_type": "image/png",
  "created_at": "2026-06-30T16:25:02Z"
}
